import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityFeatures = () => {
  const features = [
    {
      icon: 'Lock',
      title: 'Enterprise Encryptie',
      description: 'Bank-niveau beveiliging voor alle data',
      badge: 'ISO 27001',
    },
    {
      icon: 'Shield',
      title: 'Multi-Factor Auth',
      description: 'Extra beveiligingslaag voor admin toegang',
      badge: 'MFA',
    },
    {
      icon: 'FileText',
      title: 'Compliance Audit',
      description: 'Volledige audit trails voor alle acties',
      badge: 'GDPR',
    },
    {
      icon: 'Globe',
      title: 'IP Restrictie',
      description: 'Toegang beperken tot specifieke locaties',
      badge: 'Optioneel',
    },
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
        Enterprise Security
      </h3>
      <div className="space-y-4">
        {features?.map((feature, index) => (
          <div key={index} className="flex items-start space-x-3">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <Icon name={feature?.icon} size={20} color="var(--color-primary)" />
            </div>
            <div className="flex-1">
              <div className="flex items-center justify-between mb-1">
                <h4 className="text-sm font-heading font-medium text-foreground">
                  {feature?.title}
                </h4>
                <span className="text-xs font-caption px-2 py-1 bg-primary/10 text-primary rounded">
                  {feature?.badge}
                </span>
              </div>
              <p className="text-sm font-body text-muted-foreground">
                {feature?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SecurityFeatures;